import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import TimeFormat from '@/components/TimeFormat';

function Penalty({ penalty, player, isFlipped }) {
  return (
    <Grid container wrap="nowrap" spacing={1} justify={isFlipped ? "flex-end" : undefined}>
      {!isFlipped && (
        <Grid item>
          <Typography variant="caption">
            <TimeFormat time={penalty.remaining} />
          </Typography>
        </Grid>
      )}

      <Grid item>
        <Typography variant="caption">{player.name} ({penalty.penalty})</Typography>
      </Grid>
      
      {isFlipped && (
        <Grid item>
          <Typography variant="caption">
            <TimeFormat time={penalty.remaining} />
          </Typography>
        </Grid>
      )}
    </Grid>
  )
}

export default Penalty;
